export default "/_next/static/images/footerbanner-095e39266410c5e5537850c9c2970e13.png";